import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Pagination from "react-bootstrap/Pagination";
import Table from "react-bootstrap/Table";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";

const AgentManageJobsScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [ , setShowdell] = useState(false);
  const handleShowDl = () => setShowdell(true);

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <AgentSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <AgentTopHeadScreen />
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="applied-title">
                        <div className="title">
                          <h2>Manage Jobs</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="appliedJobsTable managejobtable">
                        <div className="table-responsive">
                          <Table>
                            <thead>
                              <tr>
                                <th>Jobs</th>
                                <th>Applicants</th>
                                <th>Shortlisted</th>
                                <th>Rejected</th>
                                <th>Hired</th>
                                <th>View Applicant</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <h3>Customer Care Executive</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>20</td>
                                <td>10</td>
                                <td>08</td>
                                <td>01</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Graphic Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>25</td>
                                <td>09</td>
                                <td>00</td>
                                <td>03</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Shopify Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>32</td>
                                <td>12</td>
                                <td>15</td>
                                <td>00</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Graphic Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>25</td>
                                <td>09</td>
                                <td>00</td>
                                <td>03</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Shopify Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>32</td>
                                <td>12</td>
                                <td>15</td>
                                <td>00</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Shopify Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>20</td>
                                <td>10</td>
                                <td>08</td>
                                <td>01</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3>Shopify Designer</h3>
                                  <ul className="postdate">
                                    <li>Created on: 12 Sep 2024</li>
                                    <li>Expires on: 12 Nov 2024</li>
                                  </ul>
                                </td>
                                <td>20</td>
                                <td>10</td>
                                <td>08</td>
                                <td>01</td>
                                <td>
                                  <a
                                    className="moreview"
                                    href="/agent-flow/applications"
                                  >
                                    View Applicates
                                  </a>
                                </td>
                                <td>
                                  <ul>
                                    <li>
                                      <Button
                                        className="btnnoStyle"
                                        variant="primary"
                                        onClick={handleShow}
                                      >
                                        <LuEye />
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        className="btnnoStyle red"
                                        variant="primary"
                                        onClick={handleShowDl}
                                      >
                                        {" "}
                                        <AiOutlineDelete />
                                      </Button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 paginationholder align-left mb-5">
                        <Pagination>
                          <Pagination.Prev />
                          <Pagination.Item>{1}</Pagination.Item>
                          <Pagination.Item active>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Ellipsis />
                          <Pagination.Item>{6}</Pagination.Item>
                          <Pagination.Next />
                        </Pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="afterapplied">
            <div className="aplyinfo">
              <div className="d-flex flex-btn justify-content-lg-between">
                <h4>
                  <strong>Job Title:</strong> Software Engineer
                </h4>
                <div className="status gray">Approved</div>
              </div>
              <h4>
                <strong>Category:</strong> Digital & Creative
              </h4>
              <h4>
                <strong>Type:</strong> Full Time
              </h4>
              <h4>
                <strong>Applicants:</strong> 35
              </h4>
              <h4>
                <strong>Post Date:</strong> Sep 15, 2024
              </h4>
              <h4>
                <strong>Expire Date:</strong> Oct 29, 2024
              </h4>
              <div className="flex-btn d-flex">
                <Button className="btn w-50 btn-black" variant="primary">
                  Delete Job Post
                </Button>
                <Button className="btn btn-black w-50" variant="primary">
                  View All Applicants
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AgentManageJobsScreen;
